import DesktopInteractivePlayerContainer from './DesktopInteractivePlayerContainer';
import {isServer} from "../../../utils";
import {isMobile} from 'react-device-detect';
import MobileInteractivePlayerContainer from "./MobileInteractivePlayerContainer";

let moduleDefault = {};

if (isServer()) {
  moduleDefault = () => null;
} else if (!isMobile) {
  moduleDefault = DesktopInteractivePlayerContainer;
} else {
  moduleDefault = MobileInteractivePlayerContainer;
}

module.exports = moduleDefault;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/InteractivePlayerContainer.js